var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('approve-list-setting',{attrs:{"loading":_vm.isMainLoading},on:{"onSearch":_vm.getApproveTasksSettingHistoryByMarket}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }